module.exports = __webpack_public_path__ + "img/pro_four_3.383a2868.jpg";